import { InvestorDetailsEntityTypeEnum } from '../../types';
import AllEntitiesSummaryTable from './tables/allEntitiesSummaryTable/table';
import SummaryTable from './tables/summaryTable/table';

interface ISummaryTabProps {
  entityType: InvestorDetailsEntityTypeEnum;
}

export const SummaryTab = ({ entityType }: ISummaryTabProps) => {
  return entityType === InvestorDetailsEntityTypeEnum.Household ? <AllEntitiesSummaryTable /> : <SummaryTable entityType={entityType} />;
};
